// Client-side registration of the two hire-return widgets (sprint 16). The mechanism is
// checkReminderRegistration.ts's, reused rather than repeated - see equipmentCheckRegistration.ts.

import { resolveWidgetRegistrar, type RegistrationOutcome } from "../../Compliance/CheckReminders/checkReminderRegistration";
import { HireReturnWidget, MyHireReturnsWidgetKey, ProjectHireReturnsWidgetKey } from "./hireReturnWidget";

export const HireReturnWidgetKeys = [MyHireReturnsWidgetKey, ProjectHireReturnsWidgetKey] as const;

export function registerHireReturnWidgets(scope: unknown = globalThis): boolean {
    const register = resolveWidgetRegistrar(scope);
    if (!register) return false;

    // A factory per key, each closing over its own key - one shared instance would have two cells draw
    // into one host.
    for (const key of HireReturnWidgetKeys)
        register(key, () => new HireReturnWidget(key));

    return true;
}

export function installHireReturnWidgetRegistration(
    scope: unknown = globalThis,
    doc: Pick<Document, "readyState" | "addEventListener"> | undefined =
        typeof document === "undefined" ? undefined : document,
): RegistrationOutcome {
    if (registerHireReturnWidgets(scope)) return "registered";

    // "Not complete", not "loading": see checkReminderRegistration.ts for why.
    if (doc && doc.readyState !== "complete") {
        doc.addEventListener("DOMContentLoaded", () => { registerHireReturnWidgets(scope); }, { once: true });
        return "deferred";
    }

    return "unavailable";
}
